import {
	DeviceSettings_UPDATE_REQUEST,
	DeviceSettings_UPDATE_SUCCESS,
	DeviceSettings_UPDATE_FAILURE,
	DeviceSettings_TYPE_REQUEST,
	DeviceSettings_TYPE_SUCCESS,
	DeviceSettings_TYPE_FAILURE,
	DEVICE_NETWORK_SETTINGS_GET_REQUEST,
	DEVICE_NETWORK_SETTINGS_GET_FAILURE,
	DEVICE_NETWORK_SETTINGS_GET_SUCCESS,
	DEVICE_NETWORK_SETTINGS_UPDATE_REQUEST,
	DEVICE_NETWORK_SETTINGS_UPDATE_FAILURE,
	DEVICE_NETWORK_SETTINGS_UPDATE_SUCCESS,
	DEVICE_DISPLAY_SETTINGS_GET_SUCCESS,
	DEVICE_DISPLAY_SETTINGS_GET_FAILURE,
	DEVICE_DISPLAY_SETTINGS_UPDATE_FAILURE,
	DEVICE_DISPLAY_SETTINGS_UPDATE_SUCCESS,
	DEVICE_DISPLAY_SETTINGS_UPDATE_REQUEST,
	DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_FAILURE,
	DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_SUCCESS,
	DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_REQUEST,
	DEVICE_DOOR_CONTROL_SETTINGS_GET_FAILURE,
	DEVICE_DOOR_CONTROL_SETTINGS_GET_SUCCESS,
	DEVICE_AUDIO_ALARM_SETTINGS_GET_SUCCESS,
	DEVICE_AUDIO_ALARM_SETTINGS_GET_FAILURE,
	DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_FAILURE,
	DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_SUCCESS,
	DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_REQUEST,
	DEVICE_QR_NFC_SETTINGS_GET_SUCCESS,
	DEVICE_QR_NFC_SETTINGS_GET_FAILURE,
	DEVICE_QR_NFC_SETTINGS_UPDATE_REQUEST,
	DEVICE_QR_NFC_SETTINGS_UPDATE_SUCCESS,
	DEVICE_QR_NFC_SETTINGS_UPDATE_FAILURE,
	DEVICE_PERIPHERAL_SETTINGS_GET_SUCCESS,
	DEVICE_PERIPHERAL_SETTINGS_GET_FAILURE,
	DEVICE_PERIPHERAL_SETTINGS_UPDATE_REQUEST,
	DEVICE_PERIPHERAL_SETTINGS_UPDATE_SUCCESS,
	DEVICE_PERIPHERAL_SETTINGS_UPDATE_FAILURE,
	DEVICE_PERIPHERAL_SETTINGS_GET_REQUEST,
	DEVICE_QR_NFC_SETTINGS_GET_REQUEST,
	DEVICE_AUDIO_ALARM_SETTINGS_GET_REQUEST,
	DEVICE_DOOR_CONTROL_SETTINGS_GET_REQUEST,
	DEVICE_DISPLAY_SETTINGS_GET_REQUEST,
	DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_FAILURE,
	DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_SUCCESS,
	DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_REQUEST,
	DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_REQUEST,
	DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_SUCCESS,
	DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_FAILURE,
	DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_REQUEST,
	DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_SUCCESS,
	DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_FAILURE,
	DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_REQUEST,
	DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_SUCCESS,
	DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_FAILURE,
	DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_REQUEST,
	DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_SUCCESS,
	DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_FAILURE,
	DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_REQUEST,
	DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_SUCCESS,
	DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_FAILURE
} from "./deviceSettingsConstant";

export const DeviceSettingsReducer = (
	initialState = {
		DeviceSettings: {},
		deviceNetworkSettings: {},
		deviceDisplaySettings: {},
		deviceDoorControlSettings: {},
		deviceAudioAlarmSettings: {},
		deviceQRAndNFCSettings: {},
		devicePeripheralSettings: {},

	},
	action
) => {
	switch (action.type) {
		case DeviceSettings_TYPE_REQUEST:
			return {
				...initialState,
				loading: true,
				DeviceSettings: {},
			};
		case DeviceSettings_TYPE_SUCCESS:
			return {
				...initialState,
				DeviceSettings: action.payload,
				loading: false,
			};

		case DeviceSettings_TYPE_FAILURE:
			return {
				...initialState,
				loading: false,
				getError: action.payload,
			};

		//DeviceSettings Update
		case DeviceSettings_UPDATE_REQUEST:
			return { ...initialState, updateLoading: true };
		case DeviceSettings_UPDATE_SUCCESS:
			return {
				...initialState,
				updateLoading: false,
				updateSuccess: true,
			};
		case DeviceSettings_UPDATE_FAILURE:
			return {
				...initialState,
				updateLoading: false,
				updateError: action.payload,
			};

			// Device Network Settings
			case DEVICE_NETWORK_SETTINGS_GET_REQUEST:
				return {
					...initialState,
					deviceNetworkSettings: {},
					networkLoading: true,
				};
			case DEVICE_NETWORK_SETTINGS_GET_SUCCESS:
				return {
					...initialState,
					deviceNetworkSettings: action.payload,
					networkLoading: false,
				};

			case DEVICE_NETWORK_SETTINGS_GET_FAILURE:
				return {
					...initialState,
					networkLoading: false,
					getErrorNetwork: action.payload,
				};

			//Device Network Settings Update
			case DEVICE_NETWORK_SETTINGS_UPDATE_REQUEST:
				return { ...initialState, updateNetworkLoading: true };
			case DEVICE_NETWORK_SETTINGS_UPDATE_SUCCESS:
				return {
					...initialState,
					updateNetworkLoading: false,
					updateNetworkSuccess: true,
				};
			case DEVICE_NETWORK_SETTINGS_UPDATE_FAILURE:
				return {
					...initialState,
					updateNetworkLoading: false,
					updateNetworkError: action.payload,
				};

			// Device Display Settings
			case DEVICE_DISPLAY_SETTINGS_GET_REQUEST:
				return {
					...initialState,
					deviceDisplaySettings: {},
					displayLoading: true,
				};
			case DEVICE_DISPLAY_SETTINGS_GET_SUCCESS:
				return {
					...initialState,
					deviceDisplaySettings: action.payload,
					displayLoading: false,
				};

			case DEVICE_DISPLAY_SETTINGS_GET_FAILURE:
				return {
					...initialState,
					displayLoading: false,
					getErrorDisplay: action.payload,
				};

			//Device Display Settings Update
			case DEVICE_DISPLAY_SETTINGS_UPDATE_REQUEST:
				return { ...initialState, updateDisplayLoading: true };
			case DEVICE_DISPLAY_SETTINGS_UPDATE_SUCCESS:
				return {
					...initialState,
					updateDisplayLoading: false,
					updateDisplaySuccess: true,
				};
			case DEVICE_DISPLAY_SETTINGS_UPDATE_FAILURE:
				return {
					...initialState,
					updateDisplayLoading: false,
					updateDisplayError: action.payload,
				};
			//Device Display Custom Interface Update
			case DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_REQUEST:
				return { ...initialState, updateCustomLoading: true };
			case DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_SUCCESS:
				return {
					...initialState,
					updateCustomLoading: false,
					updateCustomSuccess: true,
				};
			case DEVICE_DISPLAY_CUSTOM_INTERFACE_UPDATE_FAILURE:
				return {
					...initialState,
					updateCustomLoading: false,
					updateCustomError: action.payload,
				};
			//Device Display random keyboard Update
			case DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_REQUEST:
				return { ...initialState, updateRandomKeyboardLoading: true };
			case DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_SUCCESS:
				return {
					...initialState,
					updateRandomKeyboardLoading: false,
					updateRandomKeyboardSuccess: true,
				};
			case DEVICE_DISPLAY_RANDOM_KEYBOARD_UPDATE_FAILURE:
				return {
					...initialState,
					updateRandomKeyboardLoading: false,
					updateRandomKeyboardError: action.payload,
				};
			// Device Door Control Settings
			case DEVICE_DOOR_CONTROL_SETTINGS_GET_REQUEST:
				return {
					...initialState,
					deviceDoorControlSettings: {},
					doorControlLoading: true,
				};

			case DEVICE_DOOR_CONTROL_SETTINGS_GET_SUCCESS:
				return {
					...initialState,
					deviceDoorControlSettings: action.payload,
					doorControlLoading: false,
				};

			case DEVICE_DOOR_CONTROL_SETTINGS_GET_FAILURE:
				return {
					...initialState,
					doorControlLoading: false,
					getErrorDoorControl: action.payload,
				};

			//Device Door Control Settings Update
			case DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_REQUEST:
				return { ...initialState, updateDoorControlLoading: true };
			case DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_SUCCESS:
				return {
					...initialState,
					updateDoorControlLoading: false,
					updateDoorControlSuccess: true,
				};
			case DEVICE_DOOR_CONTROL_SETTINGS_UPDATE_FAILURE:
				return {
					...initialState,
					updateDoorControlLoading: false,
					updateDoorControlError: action.payload,
				};

			// Device Audio And Alarm Settings
			case DEVICE_AUDIO_ALARM_SETTINGS_GET_REQUEST:
				return {
					...initialState,
					deviceAudioAlarmSettings: {},
					audioAlarmLoading: true,
				};
			case DEVICE_AUDIO_ALARM_SETTINGS_GET_SUCCESS:
				return {
					...initialState,
					deviceAudioAlarmSettings: action.payload,
					audioAlarmLoading: false,
				};

			case DEVICE_AUDIO_ALARM_SETTINGS_GET_FAILURE:
				return {
					...initialState,
					audioAlarmLoading: false,
					getErrorAudiAlarm: action.payload,
				};

			//Device AUDIO_ALARM Settings Update
			case DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_REQUEST:
				return { ...initialState, updateAudioAlarmLoading: true };
			case DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_SUCCESS:
				return {
					...initialState,
					updateAudioAlarmLoading: false,
					updateAudioAlarmSuccess: true,
				};
			case DEVICE_AUDIO_ALARM_SETTINGS_UPDATE_FAILURE:
				return {
					...initialState,
					updateAudioAlarmLoading: false,
					updateAudioAlarmError: action.payload,
				};

			// Device QR And NFC Settings
			case DEVICE_QR_NFC_SETTINGS_GET_REQUEST:
				return {
					...initialState,
					deviceQRAndNFCSettings: {},
					qrAndNFCLoading: true,
				};

			case DEVICE_QR_NFC_SETTINGS_GET_SUCCESS:
				return {
					...initialState,
					deviceQRAndNFCSettings: action.payload,
					qrAndNFCLoading: false,
				};

			case DEVICE_QR_NFC_SETTINGS_GET_FAILURE:
				return {
					...initialState,
					qrAndNFCLoading: false,
					getErrorQRAndNFC: action.payload,
				};

			//Device QR And NFC Settings Update
			case DEVICE_QR_NFC_SETTINGS_UPDATE_REQUEST:
				return { ...initialState, updateQRAndNFCLoading: true };
			case DEVICE_QR_NFC_SETTINGS_UPDATE_SUCCESS:
				return {
					...initialState,
					updateQRAndNFCLoading: false,
					updateQRAndNFCSuccess: true,
				};
			case DEVICE_QR_NFC_SETTINGS_UPDATE_FAILURE:
				return {
					...initialState,
					updateQRAndNFCLoading: false,
					updateQRAndNFCError: action.payload,
				};

			// Device Peripheral Settings
			case DEVICE_PERIPHERAL_SETTINGS_GET_REQUEST:
				return {
					...initialState,
					devicePeripheralSettings: {},
					peripheralLoading: true,
				};
			case DEVICE_PERIPHERAL_SETTINGS_GET_SUCCESS:
				return {
					...initialState,
					devicePeripheralSettings: action.payload,
					peripheralLoading: false,
				};

			case DEVICE_PERIPHERAL_SETTINGS_GET_FAILURE:
				return {
					...initialState,
					peripheralLoading: false,
					getErrorPeripheral: action.payload,
				};

			//Device Peripheral Settings Update
			case DEVICE_PERIPHERAL_SETTINGS_UPDATE_REQUEST:
				return { ...initialState, updatePeripheralLoading: true };
			case DEVICE_PERIPHERAL_SETTINGS_UPDATE_SUCCESS:
				return {
					...initialState,
					updatePeripheralLoading: false,
					updatePeripheralSuccess: true,
				};
			case DEVICE_PERIPHERAL_SETTINGS_UPDATE_FAILURE:
				return {
					...initialState,
					updatePeripheralLoading: false,
					updatePeripheralError: action.payload,
				};

			//Device Peripheral Relay Cutom Settings Update
			case DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_REQUEST:
				return { ...initialState, updateRelayCustomLoading: true };
			case DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_SUCCESS:
				return {
					...initialState,
					updateRelayCustomLoading: false,
					updateRelayCustomSuccess: true,
				};
			case DEVICE_PERIPHERAL_RELAY_CUSTOM_UPDATE_FAILURE:
				return {
					...initialState,
					updateRelayCustomLoading: false,
					updateRelayCustomError: action.payload,
				};

			//Device Peripheral Event Report Settings Update
			case DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_REQUEST:
				return { ...initialState, updateEventReportLoading: true };
			case DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_SUCCESS:
				return {
					...initialState,
					updateEventReportLoading: false,
					updateEventReportSuccess: true,
				};
			case DEVICE_PERIPHERAL_EVENT_REPORT_UPDATE_FAILURE:
				return {
					...initialState,
					updateEventReportLoading: false,
					updateEventReportError: action.payload,
				};

				
			//Device Peripheral Remote Upgrade Settings Update
			case DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_REQUEST:
				return { ...initialState, updateRemoteUpgradeLoading: true };
			case DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_SUCCESS:
				return {
					...initialState,
					updateRemoteUpgradeLoading: false,
					updateRemoteUpgradeSuccess: true,
				};
			case DEVICE_PERIPHERAL_REMOTE_UPGRADE_SETTINGS_UPDATE_FAILURE:
				return {
					...initialState,
					updateRemoteUpgradeLoading: false,
					updateRemoteUpgradeError: action.payload,
				};

			//Device Peripheral Remote Upgrade Firmware Settings Update
			case DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_REQUEST:
				return { ...initialState, updateRemoteUpgradeFirmwareLoading: true };
			case DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_SUCCESS:
				return {
					...initialState,
					updateRemoteUpgrafeFirmwareLoading: false,
					updateRemoteUpgradeFirmwareSuccess: true,
				};
			case DEVICE_PERIPHERAL_REMOTE_UPGRADE_FIRMWARE_SETTINGS_UPDATE_FAILURE:
				return {
					...initialState,
					updateRemoteUpgradeFirmwareLoading: false,
					updateRemoteUpgradeFirmwareError: action.payload,
				};
		default:
			return initialState;
	}
};
